module.exports = __webpack_public_path__ + "img/22.424a2e6b.jpg";